// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip-backgroung-1 {
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 2px;
  border-radius: 2px;
  border: 2px solid var(--comms-positive-sub, #d5fbd2);
  background: var(--comms-positive-sub, #d5fbd2);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  min-width: 150px;
  justify-content: center;
}

.chip-backgroung-0 {
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 2px;
  border-radius: 2px;
  border: 2px solid var(--comms-negative-sub, #fde3d6);
  background: var(--comms-negative-sub, #fde3d6);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  min-width: 150px;
  justify-content: center;
}

.chip-backgroung-2 {
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 2px;
  border-radius: 2px;
  border: 2px solid var(--Comms-Warning-sub, #fbefcb);
  background: var(--Comms-Warning-sub, #fbefcb);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  min-width: 150px;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/chip.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oDAAoD;EACpD,8CAA8C;EAC9C,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oDAAoD;EACpD,8CAA8C;EAC9C,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".chip-backgroung-1 {\n  display: flex;\n  padding: 4px 16px;\n  align-items: center;\n  gap: 2px;\n  border-radius: 2px;\n  border: 2px solid var(--comms-positive-sub, #d5fbd2);\n  background: var(--comms-positive-sub, #d5fbd2);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  min-width: 150px;\n  justify-content: center;\n}\n\n.chip-backgroung-0 {\n  display: flex;\n  padding: 4px 16px;\n  align-items: center;\n  gap: 2px;\n  border-radius: 2px;\n  border: 2px solid var(--comms-negative-sub, #fde3d6);\n  background: var(--comms-negative-sub, #fde3d6);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  min-width: 150px;\n  justify-content: center;\n}\n\n.chip-backgroung-2 {\n  display: flex;\n  padding: 4px 16px;\n  align-items: center;\n  gap: 2px;\n  border-radius: 2px;\n  border: 2px solid var(--Comms-Warning-sub, #fbefcb);\n  background: var(--Comms-Warning-sub, #fbefcb);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  min-width: 150px;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
